<template>
  <div class="shoppe">
    <div class="upload-container">
      <el-upload
        :headers="uploadHeader"
        :action="spuImportUrl"
        :on-error="handleError"
        :on-success="handleSuccess"
        :before-upload="beforeUpload"
        :file-list="fileList">
        <el-button size="small" type="primary">请上传附件</el-button>
        <div slot="tip" class="el-upload__tip">只支持上传.xls .xlsx文件</div>
      </el-upload>
    </div>

    <el-alert v-if="result" :title="result" type="error"></el-alert>

    <p>注释：</p>
    <p>导入不可超过5万条。</p>
    <p>表格内容：spu_id</p>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import {
  spuImportUrl
} from "./api";

export default {
  data() {
    return {
      spuImportUrl,
      fileList: [],
      uploadHeader: {
        token: Cookies.get("token")
      },
      result: '',
    };
  },
  mounted() {
    
  },
  methods: {
    handleSuccess(res) {
      if (res.success) {
        if (res.data.spuNotVirtualFlagList && res.data.spuNotVirtualFlagList.length) {
          this.result = `spu未编辑：${res.data.spuNotVirtualFlagList.join(',')}`;
          this.fileList  = [];
          return;
        }
        if (res.data.spuNotVirtualFlagList && res.data.spuNotVirtualFlagList.length) {
          this.result = `未在识季上架：${res.data.spuNotVirtualFlagList.join(',')}`;
          this.fileList  = [];
          return;
        }
        if (res.data.spuNotVirtualFlagList && res.data.spuNotVirtualFlagList.length) {
          this.result = `已经在赤字：${res.data.spuNotVirtualFlagList.join(',')}`;
          this.fileList  = [];
          return;
        }
        this.$message.success('上传成功')
      } else {
        this.result = res.message;
      }
      this.fileList  = [];
    },
    handleError(err) {
      console.log(err);
      this.$message.error('上传失败，请稍后再试')
    },
    beforeUpload() {
      this.result = '';
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
.mt20 {
  margin-top: 20px;
}
.upload-container {
  width: 400px;
  height: 120px;
}
</style>
